import { ImportVehiclesHeader, ImportVehiclesTable } from '@pages/onboarding/containers';
import { saveImportedVehicles } from '@api/onboarding/onboarding.service';
import { OnboardingStep } from '@interfaces/models';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, toast } from '@ui/components';
import { Routes } from '@shared/enums';

export const OnboardingImportVehicles = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: () => saveImportedVehicles({ nextStep: OnboardingStep.IMPORT_EMPLOYEES }),
    onSuccess: () => {
      navigate(`../${Routes.IMPORT_EMPLOYEES}`);
    },
    onError: () => {
      toast.error(t(`API_ERRORS.DEFAULT`));
    },
  });

  return (
    <div>
      <ImportVehiclesHeader />
      <ImportVehiclesTable />

      <Button onClick={() => mutate()} isLoading={isPending} disabled={isPending} size="large" wide>
        {t('ONBOARDING.IMPORT_VEHICLES.SAVE_AND_CONTINUE')}
      </Button>
    </div>
  );
};
